import { render, staticRenderFns } from "./Mb.vue?vue&type=template&id=239cbde7&scoped=true&"
import script from "./Mb.vue?vue&type=script&lang=js&"
export * from "./Mb.vue?vue&type=script&lang=js&"
import style0 from "./Mb.vue?vue&type=style&index=0&id=239cbde7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239cbde7",
  null
  
)

export default component.exports